import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {APIUrl} from './constants';
import {ImagesServiceUrl} from './constants';

@Injectable({
  providedIn: 'root'
})
export class ManagementServiceService {

  readonly APIUrl = APIUrl;
  readonly ImagesServiceUrl = ImagesServiceUrl;

  constructor(private http:HttpClient) { }

  AddUpdateIndustryProductSearchResult(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/SearchIndustryProducts/Add/Update/Industry/Product/SearchResult', val)
  }

  // SearchIndustryProducts(val:any):Observable<any[]>{
  //   return this.http.post<any>(this.APIUrl + '/api/SearchIndustryProducts/Search/Industry/Products', val)
  // }

  ExportIndustryProductsStockValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Export/Industry/Products/Stock/Values', val)
  }

  ExportBulkStockValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/B2B/Export/Bulk/Stock/Values', val)
  }

    SearchIndustryProductHSCodeCOOStats(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Search/Industry/Product/HSCode/COO/Stats', val)
  }

  DeleteIndustryProductListPriceOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Industry/Product/List/Price/Offer', val)
  }

  DeleteIndustryProductStockOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Industry/Product/Stock/Offer', val)
  }

  DeleteListPriceOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/List/Price/Offers', val)
  }

  DeleteStockOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Stock/Offers', val)
  }
  
  AddUpdateListPriceOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Update/List/Price/Offer', val)
  }

  GetImportConfigurationByWarehouse(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configuration/By/Warehouse', val)
  }

  InitializeNewStockEntry(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Initialize/New/Stock/Entry', val)
  }

  GetIndustryProductsStocksFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/Stocks/Filtered/COUNT', val)
  }

  GetIndustryProductsListPriceFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/ListPrice/Filtered', val)
  }

  GetIndustryProductsListPriceFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/ListPrice/Filtered/COUNT', val)
  }

  GetIndustryProductsStocksFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/Stocks/Filtered', val)
  }

  GetFilteredBulkStockOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Filtered/Bulk/Stock/Offers', val)
  }

  GetIndustryProductsAddedOffersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/AddedOffers/Filtered', val)
  }

  GetIndustryProductsAddedOffersFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/AddedOffers/Filtered/COUNT', val)
  }

  GetIndustryProductByID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Product/By/ID', val)
  }

  GetIndustryProductListPriceOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Product/List/Price/Offers', val)
  }

  GetIndustryProductStockOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Product/Stock/Offers', val)
  }

  GetIndustryProductsMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/MasterData', val)
  }

  InitializeNewIndustryProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Initialize/New/Industry/Product', val)
  }

  UpdateGroupDiscountsData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/Group/Discounts/Data', val)
  }

  DeleteImportConfigurationDiscountGroups(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Import/Configuration/Discount/Groups', val)
  }

  DeleteImportConfigurationOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Import/Configuration/Offers', val)
  }

  ResetIndustryProductsSearchResultsVersion2(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Reset/Industry/Products/Search/Results/Version2', val)
  }

  ResetIndustryProductsSearchResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Reset/Industry/Products/Search/Results', val)
  }

  ResetAllCartItemsSearchResults(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Reset/All/CartItems/Search/Results', val)
  }

  GetBrandsFilteredWithSuggestion(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Brands/Filtered/With/Suggestion', val)
  }
  
  GetIndustryProductsListPriceOffersCleaningCount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/List/Price/Offers/Cleaning/Count', val)
  }

  CleanIndustryProductsDataOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Clean/Industry/Products/Data/Offers', val)
  }

  UpdateConfigurationPricesAndMOQ(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/Configuration/Prices/And/MOQ', val)
  }

  CleanIndustryProductsDupplicateValues(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Clean/Industry/Products/Dupplicate/Values', val)
  }

  ImportIndustryProductsToMongo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Import/Industry/Products/To/Mongo', val)
  }

  ImportIndustryProductsToElastic(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Import/Industry/Products/To/Elastic', val)
  }

  ImportIndustryProductsLiteDB(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Import/Industry/Products/Lite/DB', val)
  }

  GetConfigurationOffersCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Configuration/Offers/COUNT', val)
  }

  SearchIndustryProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Search/Industry/Products', val)
  }

  GetBrandsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Get/Brands/Filtered', val)
  }

  AddUpdateBrandLogo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Add/Update/Brand/Logo', val)
  }

  DeleteBrandLogo(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Shared/Delete/Brand/Logo', val)
  }

  AddIndustryProudct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Industry/Proudct', val)
  }

  GetIndustryProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Industry/Products/Filtered', val)
  }

  UpdateIndustryProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/Industry/Product', val)
  }

  ExportPriceList(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Export/PriceList', val)
  }

  DeleteIndustryProduct(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Industry/Product', val)
  }

  GetImportConfigurations(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configurations', val)
  }

  InitializeNewConfiguration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Initialize/New/Configuration', val)
  }

  GetImportConfigurationPositions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configuration/Positions', val)
  }

  GetImportConfigurationDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Import/Configuration/Details', val)
  }

  AddUpdateImportConfiguration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Update/Import/Configuration', val)
  }

  UpdateImportConfigurationLeadTimePriorityStrategyByBrandID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Update/ImportConfiguration/LeadTimePriorityStrategy/ByBrandID', val)
  }

  GetProductsFromConfiguration(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Products/From/Configuration', val)
  }

  GetProductsOfferingData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Products/Offering/Data', val)
  }

  GetProfitSettingsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Profit/Settings/Filtered', val)
  }

  GetProfitSettingsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Profit/Settings/Filtered/COUNT', val)
  }

  CreateShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Create/Shipping/Label', val)
  }

  PrintShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Print/Shipping/Label', val)
  }

  DeleteShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Delete/Shipping/Label', val)
  }

  RequestPickup(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Request/Pickup', val)
  }

  TrackShippingLabel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Track/Shipping/Label', val)
  }

  SimulateShippingCost(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Simulate/Shipping/Cost', val)
  }

  GetShippingMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Master/Data', val)
  }

  SearchTracking(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Search/Tracking', val)
  }

  SelectPartnerForNewShipment(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Select/Partner/For/New/Shipment', val)
  }

  GetShippingCompanyServiceTypes(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Company/Service/Types', val)
  }

  InitializeSenderReceiver(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Initialize/Sender/Receiver', val)
  }

  SelectShippingAddressFromUI(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Select/Shipping/Address/FromUI', val)
  }

  GetShippingDetails(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Details', val)
  }

  GetShipmentsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipments/Filtered', val)
  }

  SearchShipmentsFTS(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Search/Shipments/FTS', val)
  }

  TrackShippingLabelsBulk(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Track/Shipping/Labels/Bulk', val)
  }

  CompareShippingCosts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Compare/Shipping/Costs', val)
  }

  GetShippingDimentionsHistory(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Dimentions/History', val)
  }

  GetCountryShippingOptions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Country/Shipping/Options', val)
  }

  GetPartnerOpenBoxesShippingCosts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Partner/OpenBoxes/Shipping/Costs', val)
  }

  ForceShipmentClose(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Force/Shipment/Close', val)
  }

  GetUnlinkedDocumentsForPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Unlinked/Documents/For/Partner', val)
  }

  UpdateShippingDetailsTrackingStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Update/Shipping/Details/Tracking/Status', val)
  }

  SelectPartnerForNewOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Select/Partner/For/New/Order', val)
  }

  ChangeOrderStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Orders/Change/Order/Status', val)
  }

  SendContactSupportEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Send/Contact/Support/Email', val)
  }

  // ========== SHIPPING COMPANY ACCOUNTS METHODS ==========

  AddUpdateShippingCompanyAccount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Add/Update/Shipping/Company/Account', val)
  }

  GetShippingCompanyAccount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Company/Account', val)
  }

  DeleteShippingCompanyAccount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Delete/Shipping/Company/Account', val)
  }

  GetShippingCompanyAccountsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/Shipping/Company/Accounts/Filtered', val)
  }

  GetUITNumbersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/ShippingService/Get/UIT/Numbers/Filtered', val)
  }

  CheckUITStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Accounting/Check/UIT/Status', val)
  }

  // ========== OFFERS METHODS ==========

  AddNewOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Add/New/Offer', val)
  }

  GetOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer', val)
  }

  GetOfferLogs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer/Logs', val)
  }

  GetOfferItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer/Items', val)
  }

  GetOfferMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer/Master/Data', val)
  }

  GetOffersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offers/Filtered', val)
  }

  GetOffersFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offers/Filtered/COUNT', val)
  }

  GetOffersProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offers/Products/Filtered', val)
  }

  AddUpdateOfferCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Add/Update/Offer/Cart/Item', val)
  }

  UpdateOfferCartItemProgressStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Update/Cart/Item/Progress/Status', val)
  }

  DeleteOfferCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Delete/Offer/Cart/Item', val)
  }

  BulkUpdateOfferCartItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Bulk/Update/Offer/Cart/Items', val)
  }

  CancelOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Cancel/Offer', val)
  }

  ExportOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Export/Offer', val)
  }

  ExportOfferExcel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Export/Offer/Excel', val)
  }

  GetUserManagerUnreadOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/User/Manager/Unread/Offers', val)
  }

  AcceptNewlyQuotedPricesOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Accept/Newly/Quoted/Prices', val)
  }

  PreCheckOfferConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Pre/Check/Offer/Confirmation', val)
  }

  ChangeOfferStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Change/Offer/Status', val)
  }

  DownloadOfficialOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Download/Official/OfferPDF', val)
  }

  GetOfferLastSelectedAgentsAndAddressByPartnerID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Get/Offer/Last/Selected/Agents/And/Address/By/PartnerID', val)
  }
  
  IdentifyGridLeadTime(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Identify/Grid/LeadTime', val)
  }

  IdentifyGridWeight(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Identify/Grid/Weight', val)
  }

  IdentifyGridCOO(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Identify/Grid/COO', val)
  }

  IdentifyGridBrand(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Identify/Grid/Brand', val)
  }

  IdentifyPartnerWithOffers(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Identify/Partner/With/Offers', val)
  }

  UpdateOfferShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Update/Offer/Shipping/Address', val)
  }

  UpdateOfferCartLockShippingSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Update/Offer/Cart/Lock/Shipping/Settings', val)
  }

  UpdateOfferRequestShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Update/Offer/Request/Shipping/Address', val)
  }

  GetOfferRequestsProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Products/Filtered', val)
  }

  GetOfferRequestMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Master/Data', val)
  }

  GetOfferRequestsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Filtered', val)
  }

  GetOfferRequestsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Filtered/COUNT', val)
  }

  CancelOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Cancel/Offer/Request', val)
  }

  GetOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request', val)
  }

  ExportOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Export/Offer/Request', val)
  }

  ExportOfferRequestExcel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Export/Offer/Request/Excel', val)
  }

  AddNewOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Add/New/Offer/Request', val)
  }

  PreCheckOfferRequestConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Pre/Check/Offer/Request/Confirmation', val)
  }

  ChangeOfferRequestStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Change/Offer/Request/Status', val)
  }

  AcceptNewlyQuotedPricesOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Accept/Newly/Quoted/Prices', val)
  }

  GetOfferRequestLastSelectedAgentsAndAddressByPartnerID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Request/Last/Selected/Agents/And/Address/By/PartnerID', val)
  }

  DownloadOfficialOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Download/Official/OfferPDF', val)
  }

  ChangeOfferRequestCurrency(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Change/Offer/Request/Currency', val)
  }

  ChangeOfferRequestPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Change/Offer/Request/Partner', val)
  }

  AddUpdateOfferRequestCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Add/Update/Offer/Request/Cart/Item', val)
  }

  UpdateOfferRequestCartItemProgressStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Update/Cart/Item/Progress/Status', val)
  }

  DeleteOfferRequestCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Delete/Offer/Request/Cart/Item', val)
  }

  // ========== OFFER REQUESTS INDIVIDUAL ITEMS METHODS ==========

  AddUpdateOfferRequestIndividualItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Add/Update/Offer/Request/Individual/Item', val)
  }

  GetOfferRequestsIndividualItemsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OfferRequests/Get/Offer/Requests/Individual/Items/Filtered', val)
  }

  // ========== ORDER CONFIRMATIONS METHODS ==========

  UpdateOrderConfirmationShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Update/Order/Confirmation/Shipping/Address', val)
  }

  GetOrderConfirmationsProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmations/Products/Filtered', val)
  }

  GetOrderConfirmationsOnHoldProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmations/OnHold/Products/Filtered', val)
  }

  GetOrderConfirmationMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmation/Master/Data', val)
  }

  GetOrderConfirmationsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmations/Filtered', val)
  }

  GetOrderConfirmationsFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmations/Filtered/COUNT', val)
  }

  CancelOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Cancel/Order/Confirmation', val)
  }

  GetOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmation', val)
  }

  GetOrderConfirmationItemHistoryPrices(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmation/Item/History/Prices', val)
  }

  ExportOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Export/Order/Confirmation', val)
  }

  ExportOrderConfirmationExcel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Export/Order/Confirmation/Excel', val)
  }

  ExportOrderConfirmationStatusExcel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Export/Order/Confirmation/Status/Excel', val)
  }

  ExportOrderConfirmationBulkStatusExcel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Export/Order/Confirmation/Bulk/Status/Excel', val)
  }

  AddNewOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/New/Order/Confirmation', val)
  }

  PreCheckOrderConfirmationConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Pre/Check/Order/Confirmation/Confirmation', val)
  }

  ChangeOrderConfirmationStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Change/Order/Confirmation/Status', val)
  }

  AcceptNewlyQuotedPricesOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Accept/Newly/Quoted/Prices', val)
  }

  GetOrderConfirmationLastSelectedAgentsAndAddressByPartnerID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmation/Last/Selected/Agents/And/Address/By/PartnerID', val)
  }

  DownloadOfficialOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Download/Official/OrderConfirmationPDF', val)
  }

  ChangeOrderConfirmationCurrency(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Change/Order/Confirmation/Currency', val)
  }

  ChangeOrderConfirmationPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Change/Order/Confirmation/Partner', val)
  }

  AddUpdateOrderConfirmationCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/Update/Order/Confirmation/Cart/Item', val)
  }

  DeleteOrderConfirmationCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Delete/Order/Confirmation/Cart/Item', val)
  }

  BulkUpdateOrderConfirmationCartItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Bulk/Update/Cart/Items', val)
  }

  UpdateOrderConfirmationCartItemProgressStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Update/Cart/Item/Progress/Status', val)
  }

  GetOrderConfirmationItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmation/Items', val)
  }

  GetOrderConfirmationLogs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Order/Confirmation/Logs', val)
  }

  UpdateOrderConfirmationCartLockShippingSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Update/Order/Confirmation/Cart/Lock/Shipping/Settings', val)
  }

  SplitOrderConfirmationItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Split/Order/Confirmation/Item', val)
  }

  ExportOrderConfirmationProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Export/Order/Confirmations/Products', val)
  }

  GeneratePackageList(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/GeneratePackageList', val)
  }

  ValidateFullDeliveryPreCheck(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Validate/FullDelivery/PreCheck', val)
  }

  PrepareFullProcessOrderedBatches(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Prepare/Full/Process/Ordered/Batches', val)
  }

  GetBatchNotificationRecipients(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Get/Batch/Notification/Recipients', val)
  }

  RegroupBatch(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Regroup/Batch', val)
  }

  FullProcessOrderedItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Full/Process/Ordered/Items', val)
  }

  GetItemChainHistory(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Get/Item/Chain/History', val)
  }

  ChangeCartItemsStatusBulk(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Change/CartItems/Status/Bulk', val)
  }

  AddOrderConfirmationInvoicedItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/InvoicedItem', val)
  }

  DeleteOrderConfirmationInvoicedItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Delete/InvoicedItem', val)
  }

  GetOrderConfirmationInvoicedItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/InvoicedItems', val)
  }

  AddOrderConfirmationCartItemShippingData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/CartItem/ShippingData', val)
  }

  UpdateOrderConfirmationCartItemShippingData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Update/CartItem/ShippingData', val)
  }

  DeleteOrderConfirmationCartItemShippingData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Delete/CartItem/ShippingData', val)
  }

  GetOrderConfirmationCartItemShippingData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/CartItem/ShippingData', val)
  }

  UpdateOrderConfirmationShippingCost(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Update/ShippingCost', val)
  }

  AddOrderConfirmationInvoicedShippingCost(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Add/InvoicedShippingCost', val)
  }

  DeleteOrderConfirmationInvoicedShippingCost(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Delete/InvoicedShippingCost', val)
  }

  GetOrderConfirmationInvoicedShippingCosts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/InvoicedShippingCosts', val)
  }

  GetInvoiceByCartItemID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Invoice/By/CartItemID', val)
  }

  // ========== PURCHASE ORDERS METHODS ==========

  AddNewPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Add/New/Purchase/Order', val)
  }

  GetPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Order', val)
  }

  GetPurchaseOrderLogs(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Order/Logs', val)
  }

  GetPurchaseOrderItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Order/Items', val)
  }

  GetPurchaseOrderMasterData(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Order/Master/Data', val)
  }

  GetPurchaseOrdersFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Orders/Filtered', val)
  }

  GetPurchaseOrdersProductsFiltered(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Orders/Products/Filtered', val)
  }

  GetPurchaseOrdersFilteredCOUNT(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Orders/Filtered/COUNT', val)
  }

  CancelPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Cancel/Purchase/Order', val)
  }

  ExportPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Export/Purchase/Order', val)
  }

  ExportPurchaseOrderExcel(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Export/Purchase/Order/Excel', val)
  }

  BulkExportPurchaseOrders(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Bulk/Export/Purchase/Orders', val)
  }

  GetUserManagerUnreadPurchaseOrders(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/User/Manager/Unread/Purchase/Orders', val)
  }

  AcceptNewlyQuotedPricesPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Accept/Newly/Quoted/Prices', val)
  }

  PreCheckPurchaseOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Pre/Check/Purchase/Order/Confirmation', val)
  }

  ChangePurchaseOrderStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Change/Purchase/Order/Status', val)
  }

  DownloadOfficialPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Download/Official/PurchaseOrderPDF', val)
  }

  GetPurchaseOrderLastSelectedAgentsAndAddressByPartnerID(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Get/Purchase/Order/Last/Selected/Agents/And/Address/By/PartnerID', val)
  }

  UpdatePurchaseOrderShippingAddress(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Update/Purchase/Order/Shipping/Address', val)
  }

  ChangePurchaseOrderCurrency(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Change/Purchase/Order/Currency', val)
  }

  ChangePurchaseOrderPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Change/Purchase/Order/Partner', val)
  }

  AddUpdatePurchaseOrderCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Add/Update/Purchase/Order/Cart/Item', val)
  }

  DeletePurchaseOrderCartItem(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Delete/Purchase/Order/Cart/Item', val)
  }

  BulkUpdatePurchaseOrderCartItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Bulk/Update/Cart/Items', val)
  }

  UpdatePurchaseOrderCartItemProgressStatus(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Update/Cart/Item/Progress/Status', val)
  }

  UpdatePurchaseOrderCartLockShippingSettings(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Update/Purchase/Order/Cart/Lock/Shipping/Settings', val)
  }

  ApplyPurchaseOrderDiscount(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Apply/Discount', val)
  }

  GeneratePurchaseOrdersFromCartItems(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Generate/Purchase/Orders/From/Cart/Items', val)
  }

  GenerateEmptyPurchaseOrder(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/PurchaseOrders/Generate/Empty/Purchase/Order', val)
  }

  // ========== GLOBAL METHODS ==========

  AddOfferRequestFromOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Add/OfferRequest/From/Offer', val)
  }

  AddOfferFromOfferRequest(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Add/Offer/From/OfferRequest', val)
  }

  AddOfferFromOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Add/Offer/From/OrderConfirmation', val)
  }

  AddOrderConfirmationFromOffer(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Add/OrderConfirmation/From/Offer', val)
  }

  AddOfferRequestWithOrderConfirmation(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Add/OfferRequest/With/OrderConfirmation', val)
  }

  ChangeOfferCurrency(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Change/Offer/Currency', val)
  }

  ChangeOfferPartner(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Change/Offer/Partner', val)
  }

  UpdateOfferValidity(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Offers/Update/Offer/Validity', val)
  }

  SearchOfferProducts(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Search/Offer/Products', val)
  }

  GenerateOrderDocumentEmailSubject(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Generate/Order/Document/Email/Subject', val)
  }

  SendOrderDocumentEmail(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Send/Order/Document/Email', val)
  }

  BulkCreatePurchaseOrders(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Bulk/Create/PurchaseOrders', val)
  }

  // ✅ Update PDF Columns for Offer/OfferRequest/OrderConfirmation
  UpdateOrderPDFColumns(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Global/Update/Order/PDF/Columns', val)
  }

  // ========== RECEPTIONS METHODS ==========

  // Search receptions by product name/code for claims (External claims) - uses FTS stored procedure
  SearchReceptionsByProductFTS(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/Receptions/Search/Receptions/ByProduct', val)
  }

  // Get reception products for claim (similar to GetInvoiceProductsForClaim)
  GetReceptionProductsForClaim(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/OrderConfirmations/Get/Reception/Products/For/Claim', val)
  }

  // ========== WAREHOUSE ITEM POSITIONS METHODS ==========

  GetWarehouseItemPositions(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Get/Warehouse/Item/Positions', val)
  }

  AddUpdateWarehouseItemPosition(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Add/Update/Warehouse/Item/Position', val)
  }

  DeleteWarehouseItemPosition(val:any):Observable<any[]>{
    return this.http.post<any>(this.APIUrl + '/api/IndustryProducts/Delete/Warehouse/Item/Position', val)
  }
}
